"use strict";
import React from "react";
import ReactDOM from "react-dom";
import EmailMergerWrapper from "../email_merger_wrapper";
const EMAIL_ID_ATTR = "email-id";
const CARRIER_ID_ATTR = "carrier-id";
const TAG = "ht-email-merger";
class EmailMergerElement extends HTMLElement {
  static get observedAttributes() {
    return [EMAIL_ID_ATTR, CARRIER_ID_ATTR];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback(name) {
    if (name === EMAIL_ID_ATTR || name === CARRIER_ID_ATTR) {
      this.renderFromAttributes();
    }
  }
  disconnectedCallback() {
    ReactDOM.unmountComponentAtNode(this);
  }
  renderFromAttributes() {
    const emailId = this.getAttribute(EMAIL_ID_ATTR);
    if (!emailId) return;
    const carrierId = this.getAttribute(CARRIER_ID_ATTR) || "";
    ReactDOM.render(
      React.createElement(EmailMergerWrapper, {
        emailId: parseInt(emailId, 10),
        carrierId,
        mergeComplete: () => {
          this.dispatchEvent(
            new CustomEvent("merge-complete", { bubbles: true })
          );
        },
        onCancel: () => {
          this.dispatchEvent(
            new CustomEvent("merge-cancelled", { bubbles: true })
          );
        }
      }),
      this
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, EmailMergerElement);
}
